import { useTranslation } from "react-i18next";

interface Props {
  /** Already translated reasons, listed under the explanation. */
  reasons: string[];
}

/** Tooltip body explaining why a disabled action can't be used right now. */
export const ActionNotPossibleContent = ({ reasons }: Props) => {
  const { t } = useTranslation("portal");

  return (
    <>
      <span className="mb-1 block font-semibold">
        {t("common.tooltip.actionNotPossible.title")}
      </span>
      <span className="block">
        {t("common.tooltip.actionNotPossible.text", { count: reasons.length })}
      </span>
      {!!reasons.length && (
        <ul className="mt-1 list-outside list-disc pl-4">
          {reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
      )}
    </>
  );
};
